module.exports = __webpack_public_path__ + "static/media/invitedFriends_750_1000.4d8ed89f.png";